import React from 'react'

const Signup = () => {
  return (
    <div>
      {/* <!-- Button trigger modal --> */}
      <button type="button" className="btn btn-outline-primary ml-2" data-toggle="modal" data-target="#signupModel">
        <span className='fa fa-user-plus mr-1'></span>  Register
      </button>

      {/* <!-- Modal --> */}
      <div className="modal fade" id="signupModel" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Login</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <button className='btn btn-primary w-100 mb-4'>
                <span className='fa fa-google me-2'></span>   Sign up With Google
              </button>
              <button className='btn btn-primary w-100 mb-4'>
                <span className='fa fa-facebook me-2'></span>   Sign up With Facebook
              </button>
              <form>
                <div className="form-group">
                  <label htmlFor="exampleInput">Username</label>
                  <input type="text" className="form-control" id="exampleInput" />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Email address</label>
                  <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
                  <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputPassword1">Password</label>
                  <input type="password" className="form-control" id="exampleInputPassword1" placeholder="Password" />
                </div>
                <div className="form-check">
                  <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                  <label className="form-check-label" htmlFor="exampleCheck1">Check me out</label>
                </div>
                <button type="submit" className="btn btn-outline-primary w-100 mt-5">Register</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Signup